import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

export const useCardStyles = makeStyles((theme) => ({
  service: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 12px',
    backgroundColor: colorSet.gray100,
    alignItems: 'center'
  },
  wrapper: {
    display: 'flex',
    backgroundColor: colorSet.gray000,
    borderBottom: `1px solid ${colorSet.backgroundLight}`,
    padding: '20px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px'
    }
  },
  fileName: {
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colorSet.gray200,
    maxHeight: 40,
    '& > button': {
      maxHeight: 40,
      padding: 8,
      '& > svg': {
        width: 16,
        height: 16
      }
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 24
    }
  },
  infoRoot: {
    padding: '24px 16px'
  },
  textArea: {
    marginBottom: 16
  },
  validText: {
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    // eslint-disable-next-line
    ['& > button']: {
      marginLeft: 'auto',
      marginTop: 16,
      marginBottom: 24
    }
  },
  text: {
    fontWeight: 500,
    color: '#323d45',
    fontSize: 14
  },
  optionRoot: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: `0px 16px`,
    '& > :nth-child(2)': {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 243
    },
    '&.qty': {
      marginTop: 16,
      alignItems: 'center'
    }
  },
  optionTitle: {
    ...theme.typography.body2,
    fontWeight: 700,
    color: colorSet.gray900,
    display: 'block',
    width: 60
  },
  optionDetail: {
    display: 'block',
    ...theme.typography.body2,
    fontWeight: 400,
    wordBreak: 'break-all',
    '&.none': {
      color: colorSet.gray700
    },
    '& .attr': {
      display: 'block',
      ...theme.typography.caption,
      color: colorSet.errorMain,
      marginTop: 8
    }
  },
  quantityRoot: {
    maxWidth: 120,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%'
    }
  },
  quantity: {
    // '& .MuiInputBase-root': {
    //   height: 40,
    //   width: 120,
    //   [theme.breakpoints.down('xs')]: {
    //     width: '100%'
    //   }
    // }
  }
}));

export const useRequestCommentStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: colorSet.gray000,
    borderRadius: 4,
    padding: (props: { isMd?: boolean }) => (props.isMd ? '0px 0px 64px' : 0),
    marginBottom: 64,
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0px',
      marginBottom: 24
    }
  },
  bold: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8
  },
  info: {
    fontSize: 14,
    fontWeight: 400,
    color: '#939FA5',
    wordBreak: 'break-all',
    marginBottom: 16
  },
  upload: {
    marginTop: 20,
    backgroundColor: colorSet.gray000,
    borderRadius: 4,
    padding: '20px 32px',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0px'
    }
  }
}));

export const useMobileStylesDialogOption = makeStyles((theme) => ({
  mPaper: {
    maxHeight: '674px',
    overflowY: 'hidden',
    '& .viewer': {
      borderRight: `solid 1px ${colorSet.backgroundBase}`
    },
    '& .MuiDialog-paper': {
      margin: 0
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: '100%'
    }
  },
  mHeader: {
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${colorSet.backgroundBase}`,
    padding: '16px 20px',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  mTitle: {
    padding: '12px 27px',
    backgroundColor: colorSet.primary200,
    '& b': {
      fontSize: 16
    }
  },
  mContent: {
    padding: '20px',
    maxHeight: 'calc(652px - 180px)',
    overflowY: 'auto',
    '& .placeholder': {
      color: theme.palette.text.secondary
    }
  },

  mInputRoot: {
    '& input, textarea': {
      fontSize: 14,
      wordBreak: 'keep-all'
    }
  },
  mAction: {
    padding: '20px 10px',
    borderTop: `solid 1px ${colorSet.backgroundBase}`,
    justifyContent: 'center'
  },

  mSelectRoot: {
    fontSize: 14,
    padding: '10px 12px',
    '&$disabled': { backgroundColor: colorSet.backgroundLight }
  },
  mInputDetail: {
    '& input, textarea': {
      fontSizeS: 14,
      height: 100,
      wordBreak: 'keep-all'
    }
  },
  disabled: {},

  mMenuItem: {
    fontSize: 14
  }
}));

export const useDatePickerStyles = makeStyles((theme) => {
  return {
    wrapper: {
      '& .MuiPopover-paper': {
        [theme.breakpoints.down('xs')]: {
          position: 'relative'
        },
        '& .MuiPickersBasePicker-container': {
          '& .MuiPickersBasePicker-pickerView': {
            [theme.breakpoints.down('xs')]: {
              maxWidth: '100%'
            },
            '& > div': {
              '& .MuiPickersCalendarHeader-daysHeader': {
                '& > span': {
                  color: colorSet.gray900,
                  fontSize: 15
                }
              }
            }
          }
        }
      }
    },
    day: {
      '& .MuiPickersDay-hidden': {
        opacity: '0 !important'
      },
      '& .MuiPickersDay-dayDisabled': {
        opacity: '0.5'
      },
      '& > button': {
        '& > span': {
          '& > p': {}
        }
      }
    },
    sat: {
      '& .MuiPickersDay-hidden': {
        opacity: '0 !important'
      },
      '& .MuiPickersDay-dayDisabled': {
        opacity: '0.5'
      },
      '& > button': {
        '& > span': {
          '& > p': {
            color: colorSet.primary700
          }
        }
      }
    },
    sun: {
      '& .MuiPickersDay-hidden': {
        opacity: '0 !important'
      },
      '& .MuiPickersDay-dayDisabled': {
        opacity: '0.5'
      },
      '& > button': {
        '& > span': {
          '& > p': {
            color: colorSet.errorMain
          }
        }
      }
    }
  };
});

export const useRequestDrawingFilesStyles = makeStyles((theme) => ({
  drawingEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: `1px solid ${colorSet.gray300}`,
    padding: '16px 0px'
  },
  allBtn: {
    float: 'right',
    marginBottom: 12,
    '&.text': {
      transition: 'all 0.1s ease-in-out'
    },
    '&.text:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'none',
      color: colorSet.primary600
    }
  }
}));

export const useRequestProjectNameStyles = makeStyles((theme) => ({
  projectField: {
    '& .MuiInputBase-root': {
      '&>input': {
        padding: 12
      }
    },
    '& .MuiFormHelperText-root': {
      color: colorSet.errorMain
    }
  }
}));

export const useRequestExpectedBudget = makeStyles((theme) => ({
  budegetExpectRoot: {
    paddingTop: 64
  },
  textfieldErrorBase: {
    '& .MuiInputBase-root': {
      '&>input': {
        padding: 12
      }
    },
    '& .MuiFormHelperText-root': {
      color: colorSet.errorMain,
      // color: `${colorSet.gray400} `,
      position: 'absolute',
      bottom: '-25px',
      marginLeft: 0
    }
  },
  textfield: {
    '& .MuiInputBase-root': {
      '&>input': {
        padding: 12
      }
    },
    '& .MuiFormHelperText-root': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20.02px',
      color: `${colorSet.gray600} `,
      position: 'absolute',
      bottom: '-25px',
      right: 0
    }
  },
  budgetRoot: {
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 40
    }
  },
  budget: {
    marginRight: 8,
    ...theme.typography.body2,
    fontWeight: 400,
    color: colorSet.gray900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  budgetCheckboxRoot: {
    padding: '64px 0px 40px 0px'
  }
}));

export const useRequestSheetMetalStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'space-between'
  },

  extension: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 24
  },

  primaryText: {
    ...theme.typography.h4,
    fontWeight: 700,
    textAlign: 'center',
    marginTop: 12,
    marginBottom: 8
  },

  extensionRoot: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },

  extensionBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginLeft: 0,
    marginRight: 0,
    width: 'calc(100% / 2 - 6px)',
    height: '100%',
    border: `2px solid ${colorSet.gray400}`,
    borderRadius: 4,
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100%)',
      marginBottom: 16
    },
    '& .FormControlLabel': {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    '&:hover': {
      border: `2px solid ${colorSet.primary500}`
    },

    '&.checked': {
      border: `2px solid ${colorSet.primary500}`
    }
  },
  relatedServiceImage: {
    marginTop: 16,
    width: '100%',
    height: '100%',
    maxWidth: '100%'
  }
}));

export const Styles = makeStyles((theme) => {
  return {
    root: {},
    headerRoot: {
      padding: '0px 10px',
      '& .h-no': {
        width: 50
      },
      '& .h-filename': {
        width: 175
      },
      '& .h-qty': {
        width: 120
      },
      '& .h-opt': {}
    },
    contentsRoot: {}
  };
});
